<bb-amount-ui
  [currency]="'USD'"
  [amount]="2718281828"
  [mapCurrency]="true"
  [showPlusSign]="false"
  [abbreviate]="false"
></bb-amount-ui>
